"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeQueryParams = void 0;
// The table context replaces its params wholesale, so a filter bar that sends only its own fields
// arrives with everything else undefined. Copying just the named keys keeps display values like
// countTotal out of the cache key, and skipping undefined stops a filter from blanking the page.
var mergeQueryParams = function (previous, incoming, keys) {
    var merged = __assign({}, previous);
    for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
        var key = keys_1[_i];
        if (incoming[key] !== undefined)
            merged[key] = incoming[key];
    }
    return merged;
};
exports.mergeQueryParams = mergeQueryParams;
